import React from 'react';
import { GLEAP_TRIAL_OVER_FORM_KEY } from '@/utils/ts/gleap';
import { handleLogout } from '@/utils/global';
import Gleap from 'gleap';

import ButtonComponent from '@/components/common-components/ButtonComponent/ButtonComponent';
import IconContainer from '@/components/common-components/FtuxComponent/IconContainer';
import LogoutIcon from '@/components/Icons/icons/LogoutIcon';
import ModalComponent from '@/components/common-components/ModalComponent/ModalComponent';

export default function TrialOverModal({ show }: { show: boolean }) {
  if (show) {
    Gleap.startConversation();
  }

  return (
    <ModalComponent
      show={show}
      width={480}
      onClose={() => {}}
      outsideClickClose={false}
      style={{ padding: '32px' }}
      bodyStyle={{ padding: 0 }}>
      <button className="subscription-modal-logout-button" onClick={handleLogout} type="button">
        <LogoutIcon color="#FFFFFF" />
        Logout
      </button>
      <div className="warning-modal modal-main-content">
        <IconContainer icon="⏰" bgColor="rgba(229, 142, 9, 0.10)" />
        <h2 style={{ marginBottom: '24px' }}>Trial Time Ran Out!</h2>
        <p style={{ paddingBottom: '24px' }}>
          Your trial is over. We&apos;d love to officially onboard you on SARAL soon.
        </p>
        <p style={{ paddingBottom: '24px' }}>
          If you need to chat more or have questions, please reach out to your SARAL sales guide over email or reach out
          to us in the support chat below.
        </p>
        <div className="modal-footer-button-container">
          <ButtonComponent
            onClick={() => {
              Gleap.setTicketAttribute('Intent', 'My Trial is over! Please help me with account access');
              Gleap.startClassicForm(GLEAP_TRIAL_OVER_FORM_KEY, true);
            }}
            variant="secondary"
            style={{ padding: '10px 18px' }}>
            Contact Support
          </ButtonComponent>
        </div>
      </div>
    </ModalComponent>
  );
}
